import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getPageContent} from '../../Content/actions';
import {Helmet} from "react-helmet";
import LoadingSpinner from "../../Layout/components/LoadingSpinner";
import Page from "./Page";
import {withLocalize} from 'react-localize-redux';

class PageContainer extends Component {
    fetchContent() {
        const {loading} = this.props;

        const slug = this.props.match.params.slug;

        if (!loading) {
            this.props.getPageContent(slug);
        }
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        const {errors, loading} = this.props;

        if (prevProps.languages !== this.props.languages) {
            this.fetchContent();
        }

        if (prevProps.errors !== errors && loading === false) {
            if (errors.hasOwnProperty('status')) {
                switch (errors.status) {
                    case 404:
                        this.props.history.push('/404');
                        break;
                    case 303:
                        let uri = this.props.translate('routes.page_details').replace(':slug', errors.redirect);
                        this.props.history.push(uri);
                        break;
                    default:
                        break;
                }
            }
        }
    }

    render() {
        const {pages, loading} = this.props;
        const slug = this.props.match.params.slug;

        if (pages[slug] === null || pages[slug] === undefined || loading) {
            return (
                <Fragment>
                    <Helmet
                        bodyAttributes={{
                            class: 'page vertical-content-force-height-100'
                        }}
                    >
                        <title>{process.env.REACT_APP_SITE_TITLE}</title>
                    </Helmet>
                    <div className="container">
                        <div className="row mt-0 mb-0 align-items-center" style={{height: '100%'}}>
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        }

        const page = pages[slug];

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'page'
                    }}
                >
                    <title>{(page.seo_title !== '' ? page.seo_title : ReactHtmlParser(page.title.rendered)) + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE}</title>
                    {page.seo_meta_description !== '' &&
                        <meta name="description" content={page.seo_meta_description} />
                    }
                    {page.seo_facebook_og_title !== '' &&
                        <meta property="og:title" content={page.seo_facebook_og_title} />
                    }
                    {page.seo_facebook_og_description !== '' &&
                        <meta property="og:description" content={page.seo_facebook_og_description} />
                    }
                    {page.seo_facebook_og_image !== '' &&
                        <meta property="og:image" content={page.seo_facebook_og_image} />
                    }
                </Helmet>
                <div className="container">
                    <Page page={page}/>
                </div>
            </Fragment>
        );
    }
}

PageContainer.propTypes = {
    getPageContent: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    pages: state.content.pages,
    loading: state.content.pageLoading,
    errors: state.errors,
    languages: state.localize.languages,
});

export default withRouter(connect(mapStateToProps, {getPageContent})(withLocalize(PageContainer)));


// WEBPACK FOOTER //
// ./src/features/Content/components/PageContainer.js